<template>
  <iconpark-icon v-if="show" :name="name" size="16" />
</template>

<script setup lang="ts">
const props = defineProps<{ type?: number; isHot?: boolean }>()

const show = computed(
  () =>
    (props.type !== undefined &&
      [
        FILE_TYPE_MAP.IMAGE,
        FILE_TYPE_MAP.PDF,
        FILE_TYPE_MAP.PPT,
        FILE_TYPE_MAP.BACKGROUND_IMAGE,
        FILE_TYPE_MAP.VIDEO,
      ].includes(props.type as any)) ||
    props.isHot
)

const name = computed(() =>
  show.value
    ? props.isHot
      ? 'hot'
      : `${FILE_ICON_MAP[props.type as any]}-fill`
    : ''
)
</script>
